import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	choosePriorities: {
		id: 'admin-pages-priority-schemes.filter.priority-filter-picker.choose-priorities',
		defaultMessage: 'All priorities',
		description:
			'Button that shows dropdown. The dropdown allows users to choose Priorities that will be used for filtering the Priority Scheme list below. This text displays when no Priorities have been selected yet.',
	},
	multipleSelectedPriorities: {
		id: 'admin-pages-priority-schemes.filter.priority-filter-picker.multiple-selected-priorities',
		defaultMessage: '{count, plural, one {# priority selected} other {# priorities selected}}',
		description:
			'Button that shows dropdown. The dropdown allows users to choose Priorities that will be used for filtering the Priority Scheme list below. This text shows when one or more Priorities are selected in the filter.',
	},
});
